export default interface IMyTimeSelectorValue {
    value: number;
    multiply: number;
}

export const MY_TIME_SELECTOR_MULTIPLY_SECONDS = 1;
export const MY_TIME_SELECTOR_MULTIPLY_MINUTES = 60;
export const MY_TIME_SELECTOR_MULTIPLY_HOURS = 3600;
export const MY_TIME_SELECTOR_MULTIPLY_DAYS = 86400;
